/**
 * Security Configuration for MiraAdmin
 * 
 * Centralized security settings for the application.
 * Configure auto-logout and other security features here.
 */

export const SECURITY_CONFIG = {
  // Auto-logout settings
  autoLogout: {
    enabled: true,                    // Enable/disable auto-logout feature
    timeout: 500000,                    // Inactivity timeout in milliseconds (500 seconds)
    warningTime: 30000,                // Warning duration before logout (30 seconds)
    
    // Development/Testing: Use longer timeouts
    // timeout: 300000,                // 5 minutes
    // warningTime: 30000,             // 30 seconds warning
    
    // Production: Recommended timeouts
    // timeout: 900000,                // 15 minutes
    // warningTime: 60000,             // 60 seconds warning
  },
  
  // Session management
  session: {
    // Token expiration validation (implement if backend supports JWT with exp)
    validateTokenExpiration: false,
    
    // Sync logout across all browser tabs
    multiTabLogoutSync: true,
    
    // Clear all localStorage on logout
    clearStorageOnLogout: true,
  },
  
  // Activity events to monitor for user activity
  ACTIVITY_EVENTS: [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ],
  
  // LocalStorage keys
  STORAGE_KEYS: {
    ADMIN_TOKEN: 'adminToken',
    USER_INFO: 'user',
    LOGOUT_EVENT: 'logout-event',
    AUTO_LOGOUT_ACTIVITY: 'auto_logout_activity'
  },
  
  // Activity tracking (for future audit logs)
  activityTracking: {
    enabled: false,
    logActions: ['login', 'logout', 'timeout'],
  }
};

// Helper to convert milliseconds to seconds
export const msToSeconds = (ms) => Math.floor(ms / 1000);

// Helper to format time remaining
export const formatTimeRemaining = (seconds) => {
  if (seconds < 60) {
    return `${seconds} second${seconds !== 1 ? 's' : ''}`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}m ${remainingSeconds}s`;
};

export default SECURITY_CONFIG;
